/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbViewInventorySchemaRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbViewInventorySchemaRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbViewInventorySchemaRequest>): ServiceNowCmdbViewInventorySchemaRequest {
        let obj = Object.assign(new ServiceNowCmdbViewInventorySchemaRequest(), model);
        ServiceNowCmdbViewInventorySchemaRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbViewInventorySchemaRequest>): ServiceNowCmdbViewInventorySchemaRequest {
        if (!model) return null;
        return ServiceNowCmdbViewInventorySchemaRequest.newInstance(<ServiceNowCmdbViewInventorySchemaRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbViewInventorySchemaRequest) {
        if (!obj) return;

        models.ServiceNowCmdbViewInventorySchemaRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbViewInventorySchemaRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbViewInventorySchemaRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Provider to select
     */
    service_name: models.CloudServiceName;

    /**
     * Resource Category
     */
    resource_category: string;

    /**
     * Resource Type
     */
    resource_type: string;

    /**
     * Resource
     */
    resource: string;

}
